import { createBrowserHistory } from 'history';

const { baseApi, baseRecursos, baseImagenes, baseBoletin, protocolUrl, baseCms, urlMath, urlSiicex, folderResource, folderFichaProducto, folderFichaPais } = window['runConfig'];
 
export const API_URL = `${protocolUrl}://${baseApi}/api/`;
export const BASE_URL_RECURSOS = `${protocolUrl}://${baseRecursos}${folderResource}`;
export const BASE_URL_PRODUCTOS = `${protocolUrl}://${baseRecursos}${folderResource}${folderFichaProducto}/`;
export const BASE_URL_PAIS = `${protocolUrl}://${baseRecursos}${folderResource}${folderFichaPais}/`;
export const BASE_URL_IMAGENES = `${protocolUrl}://${baseImagenes}`;
export const BASE_URL_BOLETIN = `${protocolUrl}://${baseBoletin}`;
export const BASE_URL_FRONTEND = `${protocolUrl}://${baseBoletin}`;
export const BASE_URL_CMS = `${protocolUrl}://${baseCms}`;

 export const BASE_URL_RUEDAS = `${protocolUrl}://${urlMath}/`;
 export const BASE_URL_SIICEX = `${protocolUrl}://${urlSiicex}}/`;

 export const CODIGO_ESTUDIOS = '681';

 export const DOMAIN_COOKIE = `${protocolUrl}://*.${baseBoletin}`;

 export const DOMAIN_MULTIMEDIA = `${protocolUrl}://${baseRecursos}${folderResource}`;

 export const HISTORY = createBrowserHistory({
     basename: process.env.PUBLIC_URL
 });

 export const DATE_OPTIONS_SHORT = { year: 'numeric', month: 'numeric', day: 'numeric' };

 export const OPTIONS_ACTIVE = ['INACTIVO', 'ACTIVO'];
 export const SELECTED_ACTIVE = { Code: 0, Description: 'ACTIVO' };
 export const FICHA_PAIS_FOLDER = 'ficha_pais';
 export const FICHA_PRODUCTO_FOLDER = 'ficha_producto';
